import {REQUEST_FEEDBACK_REPLY, CHECK_TOKEN_FEEDBACK_REPLY_FORM, SET_FEEDBACK_REPLY_FORM, SEND_FEEDBACK_REPLY_FORM, SET_INVALID_TOKEN} from './constants'
/**
 * Export file
 * @param {string} filename prefix to be matched against
 * @param {int} outletId current outlet id export
 * @param {string} currentPage name of current page that will be displayed when export fails
 * @return {{type, payload: {filename: *, outletId: *, currentPage: *}}}
 */
export function requestFeedbackReply (token) {
  return {type: REQUEST_FEEDBACK_REPLY, payload: {token}}
}

export function checkTokenFeedbackReplyForm (token) {
  return {type: CHECK_TOKEN_FEEDBACK_REPLY_FORM, payload: token}
}

export function setFeedbackCustomers (data) {
  return {type: SET_FEEDBACK_REPLY_FORM, payload: {data}}
}

export function sendFeedbackReplyForm (message, token) {
  return {type: SEND_FEEDBACK_REPLY_FORM, payload: {message: message, token}}
}

export function setInvalidToken (status) {
  return {type: SET_INVALID_TOKEN, payload: {isValid: status}}
}



// WEBPACK FOOTER //
// ./app/actions/feedbackReplyForm/index.js